export const SET_CIDS = 'setCids'
export const SET_CID = 'setCid'
